// `key` is the label the API sends and is what the payload is matched on -- it must not
// be translated. `id` is what the user reads; the short forms keep the card narrow enough
// to sit beside its table. `color` travels with the series because the displayed name is
// translated at runtime and would otherwise miss categoryColorMap and land on the hash.
export const OUTPATIENT_APPOINTMENT_TYPES = [
  { key: 'First Visit',         id: 'hospital.analytics.appointment_types.first_visit',     color: '#1E88E5' },
  { key: 'Follow-up < 15 days', id: 'hospital.analytics.appointment_types.follow_up_lt_15', color: '#43A047' },
  { key: 'Follow-up > 15 days', id: 'hospital.analytics.appointment_types.follow_up_gt_15', color: '#8E24AA' },
  { key: 'Session',             id: 'hospital.analytics.appointment_types.session',         color: '#FFB300' },
] as const;

export const OUTPATIENT_APPOINTMENT_TYPE_ORDER = OUTPATIENT_APPOINTMENT_TYPES.map(
  (type) => type.key,
) as unknown as readonly ['First Visit', 'Follow-up < 15 days', 'Follow-up > 15 days', 'Session'];

export type OutpatientAppointmentTypeLabel = (typeof OUTPATIENT_APPOINTMENT_TYPE_ORDER)[number];

export function normalizeDepartmentTypePercentages(values: number[]): number[] {
  const total = values.reduce((sum, value) => sum + value, 0);
  if (total <= 0) {
    return values.map(() => 0);
  }

  const scaled = values.map((value) => (value / total) * 100);
  const rounded = scaled.map((value) => Number(value.toFixed(1)));
  const drift = Number((100 - rounded.reduce((sum, value) => sum + value, 0)).toFixed(1));
  if (drift !== 0 && rounded.length > 0) {
    const lastIndex = rounded.length - 1;
    rounded[lastIndex] = Number((rounded[lastIndex] + drift).toFixed(1));
  }
  return rounded;
}
